import { RootState } from "../../../app/store";
import { ThreadMessagesState } from "../messages-slice";
import { channelKey, MessagesChannel } from "../models/MessagesChannel";
import { MessageThread } from "../models/MessageThread";
import { SessionCard } from "../models/SessionCard";

const NO_THREADS: MessageThread[] = [];

export const selectThreads = (channel: MessagesChannel) => (state: RootState): MessageThread[] =>
  state.messages.threadsByChannel[channelKey(channel)] ?? NO_THREADS;

export const selectThreadsStatus = (state: RootState) => state.messages.threadsStatus;

export const selectThreadMessages = (threadId: string) => (state: RootState): ThreadMessagesState | undefined =>
  state.messages.messagesByThreadId[threadId];

export const selectUnreadCount = (channel: MessagesChannel) => (state: RootState): number =>
  state.messages.unreadByChannel[channelKey(channel)] ?? 0;

export const selectSendStatus = (state: RootState) => state.messages.sendStatus;

export const selectSessionCard = (threadId: string) => (state: RootState): SessionCard | undefined =>
  state.messages.sessionCardsByThreadId[threadId];
